var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5176 7.59246C23.7719 6.43975 22.6566 5.45859 21.5457 5.85766L4.08389 12.1303C2.86626 12.5677 2.7128 14.2857 3.93747 14.8722C4.84359 15.3061 6.23166 15.9456 7.62894 16.491C8.77507 16.9383 10.0278 17.3637 11.0414 17.5195C11.3024 17.8682 11.6363 18.2076 11.9772 18.5201C12.4993 18.9987 13.1322 19.4974 13.7873 19.9775C15.0992 20.939 16.5622 21.8701 17.5493 22.477C18.729 23.2023 20.2245 22.5204 20.5142 21.2077L23.5176 7.59246ZM5.92587 13.5937L21.3694 8.0461L18.5661 20.7544C17.5981 20.1586 16.2044 19.2694 14.9695 18.3644C14.3447 17.9065 13.7759 17.4557 13.3285 17.0457C13.1692 16.8997 13.0349 16.7673 12.9233 16.6492L17.0912 12.9062C17.5021 12.5372 17.536 11.9049 17.167 11.494C16.798 11.0831 16.1657 11.0491 15.7549 11.4181L11.1902 15.5174C10.4628 15.3844 9.45649 15.0574 8.35614 14.628C7.50934 14.2974 6.65989 13.928 5.92587 13.5937Z",
    fill: "#57A8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.ff8b24e99cac0f7656761665e3bf14b6.svg";
export { ForwardRef as ReactComponent };